<script>
import { mapActions } from "pinia";
import { newsStore } from "@/store/newsStore";

export default {
  props: {
    news: {
      type: Object,
    },
  },
  methods: {
    ...mapActions(newsStore, ['updateConsolidatedNewsList']),
  },
};
</script>

<template>
<div>
  <router-link
    :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    class="member-name"
  >{{news.textParams[1]}}</router-link>
  {{$t('news.template.proposal.publishByMultiple.p1')}}
  <a href="#">{{news.textParams[8]}}
    {{$t('news.template.proposal.publishByMultiple.p2')}}
  </a>
  {{$t('news.template.proposal.publishByMultiple.p3')}}
  <router-link
    :to="{name: 'ProposalView', params: {id: news.textParams[3]}}"
  >{{news.textParams[4]}}</router-link>
  {{$t('news.template.proposal.publishByMultiple.p4')}}
  <router-link :to="{name: 'forum', params: {id: news.textParams[5]}}"
  >{{news.textParams[6]}}</router-link>.
</div>
</template>
